































import { Component, Vue } from 'vue-property-decorator';
import AsyncLoading from '@/components/base/AsyncLoading.vue';
import AsyncError from '@/components/base/AsyncError.vue';

const DeviceFieldsTab = () => ({
  component: import('./SettingsCardTabs/DeviceFieldsTab.vue'),
  loading: AsyncLoading,
  error: AsyncError,
  delay: 0,
  timeout: 3000
});

const DeviceHintsTab = () => ({
  component: import('./SettingsCardTabs/DeviceHintsTab.vue'),
  loading: AsyncLoading,
  error: AsyncError,
  delay: 0,
  timeout: 3000
});

@Component({
  components: {
    DeviceFieldsTab,
    DeviceHintsTab
  }
})
export default class SettingsCard extends Vue {
  selectedItem = 0;

  get items() {
    return [
      { name: this.$t(`settings.deviceDetails`), component: DeviceFieldsTab },
      { name: this.$t(`settings.hintDetails`), component: DeviceHintsTab }
    ];
  }

  get currentComponent() {
    return this.items[this.selectedItem]?.component || null;
  }
}
